export function getTemperatureMetrics(metric?: string): string {
  switch (metric) {
    case "C":
      return "Celsius (°C)";
    case "F":
      return "Fahrenheit (°F)";
    default:
      return "";
  }
}

export function getSpeedMetrics(metric?: string): string {
  switch (metric) {
    case "km":
      return "Kilometers (km)";
    case "mi":
      return "Miles (mi)";
    default:
      return "";
  }
}
